module.exports = __webpack_public_path__ + "img/f-9-1.68e0e01b.png";